import { User } from 'entities/User';
import { ENTERED_USER_DETAILS_KEY } from '../constants';

export const getEnteredUserDetails = (): Nullable<User> => {
  const data = localStorage.getItem(ENTERED_USER_DETAILS_KEY);

  const enteredUserData = data ? JSON.parse(data) : null;

  return enteredUserData;
};
